import { makeStyles } from 'tss-react/mui';

const useStylesAppBar: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  appBar: {
    height: 64,
    zIndex: '1300 !important',
  },
  appBarActive: {
    minWidth: 320,
    justifyContent: 'left',
    paddingRight: '0 !important',
  },
  appBarDefault: {
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default useStylesAppBar;
